// removed by extract-text-webpack-plugin
module.exports = {"selector":"CurrencyDropdown-style__selector__e3020f64","label":"CurrencyDropdown-style__label__e3020f64","value":"CurrencyDropdown-style__value__e3020f64","arrow":"CurrencyDropdown-style__arrow__e3020f64","dropdown":"CurrencyDropdown-style__dropdown__e3020f64","option":"CurrencyDropdown-style__option__e3020f64","optionLabel":"CurrencyDropdown-style__optionLabel__e3020f64","checkmark":"CurrencyDropdown-style__checkmark__e3020f64"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/CurrencySelector/CurrencyDropdown-style.scss
// module id = ./src/components/Footer/CurrencySelector/CurrencyDropdown-style.scss
// module chunks = 13